// @ts-nocheck
import React, { useState, useEffect } from 'react';

import 'tippy.js/dist/tippy.css'; // optional

import KwPanel from '../../../common/KwPanel';
import { NavLink } from 'react-router-dom';
import icons from '../../../../constants/icons';
import Button from '../../../common/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import workflowHelp from '../../../../constants/help/workflowHelp';
import Help from '../../../common/Help';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

const TerritoryRestrictions = ({
  register,
  setValue,
  restricted,
  restrictions,
  territories,
  locked,
}) => {
  const { t } = useTranslation();
  const language = i18next.language;
  const [mode, setMode] = useState(
    restricted && restrictions?.length > 0
      ? 'Disallow'
      : !restricted && restrictions?.length > 0
        ? 'Allow Only'
        : 'Unrestricted'
  );
  const [territory, setTerritory] = useState();
  const [territoryRestrictions, setTerritoryRestrictions] = useState(
    restrictions || []
  );

  const handleOnModeChange = (value) => {
    if (!locked) {
      setMode(value);
      setValue('disallowListedTerritories', value);
    }
  };

  const handleOnAdd = () => {
    if (!territory) {
      return;
    }
    if (!territoryRestrictions.find((x) => x.id === territory.id)) {
      const updatedTerritoryRestrictions = [
        ...territoryRestrictions,
        territory,
      ];
      setTerritoryRestrictions(updatedTerritoryRestrictions);
      setValue('territories', updatedTerritoryRestrictions);
    }
  };

  const handleOnChange = (e) => {
    if (!locked) {
      setTerritory(territories.find((x) => x.id === e.target.value));
    }
  };

  const handleOnRemove = (id) => {
    if (!locked) {
      const updatedTerritoryRestrictions = territoryRestrictions.filter(
        (x) => x.id !== id
      );
      setTerritoryRestrictions(updatedTerritoryRestrictions);
      setValue('territories', updatedTerritoryRestrictions);
    }
  };

  const handleOnClear = () => {
    if (!locked) {
      setTerritoryRestrictions([]);
      setValue('territories', []);
    }
  };

  useEffect(() => {
    setValue('disallowListedTerritories', mode);
  });

  return (
    <KwPanel className="mb-4">
      <header className="space-bottom" style={{ justifyContent: 'flex-start' }}>
        <h2 className="space-right">{t('Territory restrictions')}</h2>
        <Help
          helpContent={workflowHelp.WORKFLOW_RESTRICTIONS[language]}
          size={'2x'}
        />
      </header>
      <div className="row">
        <div className="col-sm-6">
          <div
            className="toggle-group"
            register={register('disallowListedTerritories')}
          >
            <label
              data-cy="territory-unrestricted"
              onClick={(e) => handleOnModeChange('Unrestricted')}
              className={`${mode === 'Unrestricted' ? 'checked' : ''}`}
            >
              {t('Unrestricted')}
            </label>
            <label
              data-cy="territory-allow-only"
              onClick={(e) => handleOnModeChange('Allow Only')}
              className={`${mode === 'Allow Only' ? 'checked' : ''}`}
            >
              {t('Allow only')}
            </label>
            <label
              data-cy="territory-disallow"
              onClick={(e) => handleOnModeChange('Disallow')}
              className={`${mode === 'Disallow' ? 'checked' : ''}`}
            >
              {t('Disallow')}
            </label>
          </div>
        </div>
        {mode !== 'Unrestricted' && (
          <>
            {!locked && (
              <div className="col-sm-6 text-right select-filter right">
                <select
                  data-cy="territory-restrictions-select"
                  disabled={locked}
                  className="form-control"
                  style={{ display: 'inline-block', width: '50%' }}
                  onChange={handleOnChange}
                >
                  <option value="">{t('--- choose ---')}</option>
                  {territories &&
                    [...territories]
                      ?.sort((a, b) => a.name.localeCompare(b.name))
                      .map((x) => (
                        <option key={x.id} value={x.id}>
                          {x.name}
                        </option>
                      ))}
                </select>
                <Button
                  testId="territory-restrictions-add"
                  isDisabled={locked || !territory}
                  type="submit"
                  className="btn btn-primary r-corners-right"
                  onClick={handleOnAdd}
                  text={t('Add')}
                />
              </div>
            )}
            <div className="col-sm-12">
              <div
                className="tags space-top"
                register={register('territories')}
              >
                {territoryRestrictions?.map((x) => (
                  <div key={x.id} className="tag">
                    <NavLink
                      to={`/settings/territory/${x.id}`}
                      title={`${x.description}\n${t('Click to view')}`}
                    >
                      {x.name}
                    </NavLink>
                    {!locked && (
                      <span
                        className="ms-3 a"
                        onClick={() => handleOnRemove(x.id)}
                        title={t('Remove')}
                      >
                        <FontAwesomeIcon icon={icons.DELETE_TAG} />
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
      {mode !== 'Unrestricted' && (
        <div className="text-right mt-3 ">
          <Button
            className="btn btn-primary"
            isDisabled={territoryRestrictions?.length === 0}
            onClick={handleOnClear}
            text={t('Clear all')}
          />
        </div>
      )}
    </KwPanel>
  );
};



export default TerritoryRestrictions;
